import { z } from "zod";
import * as themeScheme from "@ecp-redux/dto/themeSettings/themeSettings.schemes";

export const IBoxAccountRequestSentMessagesScheme = z.object({
  account_request_sent_title: themeScheme.MessageScheme.default(
    "Prośba o założenie konta została wysłana"
  ),

  account_request_sent_subtitle: themeScheme.MessageScheme.default("Co dalej?"),
  account_request_sent_first_step: themeScheme.MessageScheme.default(
    "Skontaktuje się z Tobą jeden z naszych Przedstawicieli handlowych, który będzie najbliżej Twojej lokalizacji"
  ),
  account_request_sent_second_step: themeScheme.MessageScheme.default(
    "Po pozytywnej weryfikacji, zostanie przesłana do Ciebie umowa na dostęp do portalu Unimax"
  ),
  account_request_sent_third_step: themeScheme.MessageScheme.default(
    "Po zakończeniu formalności na podany e-mail otrzymasz link aktywujący dostęp do portalu"
  ),
  account_request_sent_button_text: themeScheme.MessageScheme.default(
    "Przejdź do strony glównej"
  ),
});

export const IBoxAccountRequestSentSettingsScheme = z.object({
  account_request_sent_title_typo:
    themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  account_request_sent_title_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  account_request_sent_subtitle_typo:
    themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  account_request_sent_subtitle_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  account_request_sent_step_typo:
    themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  account_request_sent_step_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  account_request_sent_step_message_typo:
    themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  account_request_sent_step_message_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  account_request_sent_button_style:
    themeScheme.ButtonIdScheme.default("button$$1"),
  account_request_sent_redirect_on_button_click:
    themeScheme.UrlScheme.default("").catch(""),
});
